import { cn as e } from "../../lib/utils.js";
import { Avatar as t, AvatarFallback as n, AvatarImage as r } from "../primitives/avatar.js";
import * as i from "react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/composed/avatar-group.tsx
var s = {
	sm: "h-8 w-8 text-xs",
	md: "h-10 w-10 text-sm",
	lg: "h-12 w-12 text-base"
}, c = {
	sm: "-ml-3",
	md: "-ml-4",
	lg: "-ml-5"
}, l = (e) => {
	let t = e.trim().split(/\s+/);
	return t.length === 1 ? t[0].substring(0, 2).toUpperCase() : (t[0][0] + t[t.length - 1][0]).toUpperCase();
}, u = i.forwardRef(({ avatars: i, max: u = 3, size: d = "md", className: f, onMoreClick: p }, m) => {
	let h = i.slice(0, u), g = Math.max(0, i.length - u);
	return /* @__PURE__ */ o("div", {
		ref: m,
		className: e("flex items-center", f),
		children: [h.map((i, u) => {
			var f;
			return /* @__PURE__ */ o(t, {
				className: e(s[d], u > 0 && c[d], "border-2 border-white"),
				children: [/* @__PURE__ */ a(r, {
					src: i.src,
					alt: i.alt
				}), /* @__PURE__ */ a(n, { children: i.fallback || l(i.alt) })]
			}, (f = i.src) == null ? i.alt || String(u) : f);
		}), g > 0 && /* @__PURE__ */ o("div", {
			className: e(s[d], c[d], "flex items-center justify-center rounded-full bg-neutral-200 border-2 border-white text-neutral-700 font-medium", p && "cursor-pointer hover:bg-neutral-300 transition-colors"),
			onClick: p,
			role: p ? "button" : void 0,
			tabIndex: p ? 0 : void 0,
			onKeyDown: p ? (e) => {
				(e.key === "Enter" || e.key === " ") && (e.preventDefault(), p());
			} : void 0,
			children: ["+", g]
		})]
	});
});
u.displayName = "AvatarGroup";
//#endregion
export { u as AvatarGroup };

//# sourceMappingURL=avatar-group.js.map